import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftX: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-left-x, delete, remove, backspace"><path d="M11.2483 10L15.25 14.0017M15.2517 10L11.25 14.0017M2.75 12L7.75 4.75H21.25V19.25H7.75L2.75 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowLeftX;
